var map = {
	"./site-copacabana (3).webp": 9797,
	"./site-copacabana (4).webp": 6889,
	"./site-copacabana (6).webp": 9235,
	"./tela-azul-marinho-site (1).webp": 8347,
	"./tela-azul-marinho-site (11).webp": 4907,
	"./tela-azul-marinho-site (13).webp": 9760,
	"./tela-azul-marinho-site (17).webp": 3469,
	"./tela-azul-marinho-site (19).webp": 7709,
	"./tela-azul-marinho-site (2).webp": 6751,
	"./tela-azul-marinho-site (6).webp": 611,
	"./tela-azul-marinho-site (8).webp": 3817,
	"./tela-azul-marinho12.webp": 4873
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7362;